import { PluginState } from "../render-store/render.store";

// 1. Helper to yield execution to the next microtask/tick
const tick = () => new Promise(resolve => setTimeout(resolve, 0));

export async function processAndValidatePlugins(pluginsObj: Record<string, PluginState>) {
  const failedPlugins: any = [];

  // Iterate over each plugin key
  for (const pluginId of Object.keys(pluginsObj)) {
    const plugin = pluginsObj[pluginId];

    // 1. Run the onBeforeSubmit hook safely
    if (typeof plugin.onBeforeSubmit === 'function') {
      try {
        plugin.onBeforeSubmit();
        
        // CRITICAL GAP BRIDGE: Pause execution for a split second.
        // This allows Angular signals updated via `patchData` to flush 
        // their new values back into the store.
        await tick(); 
        
      } catch (err) {
        console.error(`Error running onBeforeSubmit for plugin ${pluginId}:`, err);
      }
    }

    // 2. Fetch the updated plugin reference (in case the object reference changed in the store)
    const updatedPlugin = pluginsObj[pluginId];

    // 3. Run the validate function safely
    if (typeof updatedPlugin.validate === 'function') {
      try {
        const isValid = updatedPlugin.validate();

        if (!isValid) {
          failedPlugins.push({
            id: pluginId,
            error:
              updatedPlugin.error ||
              'Validation failed without a specific error message.',
          });
        }
      } catch (err) {
        console.error(`Error running validate for plugin ${pluginId}:`, err);
      }
    }
  }

  // --- Final Results Check ---
  if (failedPlugins.length === 0) {
    return true;
  } else {
    console.error('Form submission blocked. The following plugins failed validation:');
    console.table(failedPlugins);
    return false;
  }
}